import { render, staticRenderFns } from "./impact-growth.vue?vue&type=template&id=4069a6d4"
import script from "./impact-growth.ts?vue&type=script&lang=ts&external"
export * from "./impact-growth.ts?vue&type=script&lang=ts&external"
import style0 from "./impact-growth.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports